import { baseColors } from "@Constants/baseStyles"
import * as React from "react"
import Svg, { Path } from "react-native-svg"

const SvgNext = (props) => {
    return (
        <Svg xmlns="http://www.w3.org/2000/svg" width={12} height={12} fill="none" viewBox="0 0 12 12" {...props}>
            <Path
                fill={baseColors.green.primary}
                d="M3.048.192l-.395.393a.652.652 0 00-.192.464c0 .176.068.34.192.464l4.484 4.484-4.49 4.49a.651.651 0 00-.19.463.65.65 0 00.19.465l.394.393a.657.657 0 00.928 0l5.364-5.345a.671.671 0 00.21-.465v-.002a.67.67 0 00-.21-.464L3.983.192a.663.663 0 00-.935 0z"
            />
        </Svg>
    )
}

export default SvgNext
